import InterviewSuggestForm, {
  initialState,
  State,
} from 'components/Interview/SuggestForm';
import { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import useSWR from 'swr';
import Mentorship from 'types/Mentorship';

const SuggestInterview: FC = () => {
  const { id } = useParams();
  const { data: mentorship } = useSWR<Mentorship>(
    `/mentorship/mentor/mentee-details/${id}`,
  );

  const [state, setState] = useState<State>(initialState);

  useEffect(() => {
    if (id) {
      setState((prev) => ({
        ...prev,
        mentorshipId: parseInt(id),
      }));
    }
  }, [id]);
  return (
    <InterviewSuggestForm
      {...{ state, setState, mentorship }}
      backTo={`/mentor/mentorship/management/mentees/details/${id}/interviews/`}
      fixedMentee
    />
  );
};

export default SuggestInterview;
